<template>
    <div>
        <b-container class="mt4 mb-4" fluid>
          <!-- tiendas -->
          <b-card v-if="user.rol=='Admin'">
            <template slot="header">
              <i class="fa fa-building"></i> Direcciones
              <div class="float-right">
                <b-input-group prepend="Mostrar">
                  <b-form-select v-model="sperPage" @change="getStores()" :options="soptions" />
                </b-input-group>
              </div>
            </template>
             <!-- buscador de series por RUC -->
                    <b-row >
                        <b-col cols="3" class="mb-4">
                            <b-input-group>
                                <b-input-group-append is-text >
                                <i class="fa fa-search"></i>                
                                </b-input-group-append>
                                <b-form-input type="number" @keyup.enter="validarRUC()" v-model="consultaRuc" maxlength="11" placeholder="RUC" ></b-form-input>
                            </b-input-group>
                            
                        </b-col>
                        <b-col> 
                            <b-button class="mt-1" variant="info" @click="limpiarRUC()" title="Limpiar" size="sm"><i class="fa fa-eraser"></i></b-button>
                        </b-col>
                    </b-row>
                  <!-- fin de buscador de series por RUC -->
            <template v-if="loadingstores">
              <b-row>
                <b-col class="text-center">
                  <h5 class="display-5">
                    <i class="fa fa-spin fa-spinner"></i> Cargando Tiendas
                  </h5>
                </b-col>
              </b-row>
            </template>
            <template v-else>
              <b-table striped hover :items="stores" :fields="storeitems" outlined>
                <template slot="index" slot-scope="data">{{data.index + 1}}</template>
                <template
                  slot="registro"
                  slot-scope="data"
                >{{data.item.created_at | moment('DD-MM-YYYY hh:mm:ss A')}}</template>
                <template slot="acciones" slot-scope="data">
                  <!-- <b-button-group v-if="data.item.codigoEstablecimiento!='0001'"> -->
                    <b-button variant="primary" @click="setStore(data.item)"><i class="fa fa-edit"></i></b-button>
                    <b-button variant="danger" @click="borrarEstablecimiento(data.item)"><i class="fa fa-trash"></i></b-button>
                  <!-- </b-button-group> -->
                </template>
              </b-table>
              <b-pagination
                v-model="scurrentPage"
                :per-page="sperPage"
                :total-rows="srows"
                size="sm"
                @input="getStores()"
                align="center"
              />
              <b-modal title="Nueva Tienda" size="lg" v-model="modalstore">
                <b-row>
                  <b-col>
                    <b-form-group label="Nombre de Tienda" :state="Boolean(namestore!=='')">
                      <b-form-input :state="Boolean(namestore!=='')" v-model.trim="namestore"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Código de Tienda" :state="Boolean(codestore!=='')">
                      <b-form-input :state="Boolean(codestore!=='')" v-model.trim="codestore"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- seleccionar ubigeo -->
                <b-row>
                  <b-col>
                    <label><b>Datos Ubigeo Partida</b></label>
                    <hr style="background-color:#D5E6FA; height:5px;">
                    <b-row>
                      <b-col>
                         <template>
                            <h5>Seleccione Departamento</h5>
                            <select class="custom-select mr-sm-2" v-model="departamentoUbigeo">
                                    <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{departamento.nombre}} </option>
                            </select>
                         </template>
                      </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                           <template>
                            <h5>Seleccione Provincia</h5>
                            <div v-if="!provOrigen">
                               <b-form-input 
                                    type="text"
                                    disabled
                                    placeholder="Selecciona una Provincia...">
                                </b-form-input>
                            </div>
                            <div v-else-if="provOrigenCargando">
                                    Cargando <i class="fa fa-spin fa-spinner"></i>
                            </div>
                            <div v-else>
                            <select class="custom-select mr-sm-2" v-model="provinciaUbigeo" >
                                    <option v-for="provincia in listProvinceOrigen.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                            </select>
                            </div>
                         </template>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                          <template>
                            <h5>Seleccione Distrito</h5>
                            <div v-if="!distOrigen">
                                    <b-form-input 
                                        type="text"
                                        disabled
                                        placeholder="Selecciona una Distrito...">
                                    </b-form-input>
                            </div>
                            <div v-else-if="distOrigenCargando">
                                   Cargando <i class="fa fa-spin fa-spinner"></i>
                            </div>
                            <div v-else>
                            <select class="custom-select mr-sm-2"  v-model="distritoUbigeo">
                                    <option v-for="distrito in listDistrictOrigen.Departments" :value="distrito" :key="distrito.codDistrito">{{distrito.nombre}}</option>
                            </select>
                            </div>
                          </template>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col cols="3">
                          <template>
                            <b-form-input disabled placeholder="codigo ubigeo partida" v-model="ubigeoPartida"></b-form-input>
                          </template>
                        </b-col>
                        <b-col cols="9">
                          <template>
                            <b-form-input maxlength="100" placeholder="Direccion de partida" v-model="direcUbigeo"></b-form-input>
                          </template>
                        </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                  <!-- FIN seleccionar ubigeo -->
                <template slot="modal-footer">
                  <div>
                    <template v-if="!loadingstores2">
                      <b-button class="mr-2" @click="modalstore = false">
                        <i class="fa fa-times"></i> Cancelar
                      </b-button>
                      <b-button
                        variant="primary"
                        @click="saveStore()"
                        :disabled="!Boolean(namestore!=='' && codestore!=='' && ubigeoPartida!==''&& direcUbigeo!=='')"
                      >
                        <i class="fa fa-save"></i> Grabar
                      </b-button>
                    </template>
                    <template v-else>
                      <b-button variant="secondary" disabled>
                        <i class="fa fa-spin fa-spinner"></i> Grabando
                      </b-button>
                    </template>
                  </div>
                </template>
              </b-modal>
              <b-modal title="Editar Tienda" size="lg" v-model="modalupdate">
                <b-row>
                  <b-col>
                    <b-form-group label="Nombre de Tienda" :state="Boolean(namestore!=='')">
                      <b-form-input
                        :state="Boolean(editnamestore!=='')"
                        v-model.trim="editnamestore"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                   <b-col>
                    <b-form-group label="Código de Tienda" :state="Boolean(codestore!=='')">
                      <b-form-input
                        :state="Boolean(editcodestore!=='')"
                        v-model.trim="editcodestore"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                 <!-- seleccionar ubigeo -->
                <b-row>
                  <b-col>
                    <label><b>Datos Ubigeo Partida</b></label>
                    <hr style="background-color:#D5E6FA; height:5px;">
                    <b-row>
                      <b-col>
                         <template>
                            <h5>Seleccione Departamento</h5>
                            <select class="custom-select mr-sm-2" v-model="departamentoUbigeo">
                                    <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{departamento.nombre}} </option>
                            </select>
                         </template>
                      </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                           <template>
                            <h5>Seleccione Provincia</h5>
                            <div v-if="!provOrigen">
                               <b-form-input 
                                    type="text"
                                    disabled
                                    placeholder="Selecciona una Provincia...">
                                </b-form-input>
                            </div>
                            <div v-else-if="provOrigenCargando">
                                    Cargando <i class="fa fa-spin fa-spinner"></i>
                            </div>
                            <div v-else>
                            <select class="custom-select mr-sm-2" v-model="provinciaUbigeo" >
                                    <option v-for="provincia in listProvinceOrigen.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                            </select>
                            </div>
                         </template>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                          <template>
                            <h5>Seleccione Distrito</h5>
                            <div v-if="!distOrigen">
                                    <b-form-input 
                                        type="text"
                                        disabled
                                        placeholder="Selecciona una Distrito...">
                                    </b-form-input>
                            </div>
                            <div v-else-if="distOrigenCargando">
                                   Cargando <i class="fa fa-spin fa-spinner"></i>
                            </div>
                            <div v-else>
                            <select class="custom-select mr-sm-2"  v-model="distritoUbigeo">
                                    <option v-for="distrito in listDistrictOrigen.Departments" :value="distrito" :key="distrito.codDistrito">{{distrito.nombre}}</option>
                            </select>
                            </div>
                          </template>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col cols="3">
                          <template>
                            <b-form-input disabled placeholder="codigo ubigeo partida" v-model="ubigeoPartida"></b-form-input>
                          </template>
                        </b-col>
                        <b-col cols="9">
                          <template>
                            <b-form-input maxlength="100" placeholder="Direccion de partida" v-model="direcUbigeo" ></b-form-input>
                          </template>
                        </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                 <!-- FIN seleccionar ubigeo -->
                <template slot="modal-footer">
                  <div>
                    <template v-if="!loadingstores3">
                      <b-button class="mr-2" @click="modalupdate = false">
                        <i class="fa fa-times"></i> Cancelar
                      </b-button>
                      <b-button
                        variant="primary"
                        @click="updateStore()"
                        :disabled="!Boolean(editnamestore!=='' && editcodestore!=='')"
                      >
                        <i class="fa fa-save"></i> Actualizar
                      </b-button>
                    </template>
                    <template v-else>
                      <b-button variant="secondary" disabled>
                        <i class="fa fa-spin fa-spinner"></i> Actualizando
                      </b-button>
                    </template>
                  </div>
                </template>
              </b-modal>
            </template>
            <template slot="footer">
              <div class="animated fadeIn">
                <b-button type="button" variant="primary" @click="modalstore = true">
                  <i class="fa fa-plus"></i> Agregar
                </b-button>
              </div>
            </template>
          </b-card>
        </b-container>
        <vue-snotify></vue-snotify>
    </div>
</template>
<script>
import axios from "axios";
import { TipoMoneda } from "@/shared/utils";
import Tag from "@/components/userpanel/tag";
import { Departamentos } from '@/shared/utils';
export default {
    name:"direccionesSoporteData",
    components: { Tag },
    data() {
        return {
            cargando:true,
            checked: false,
            ancho: "",
            alto: "",
            cargarimpresion: false,
            responseinfoclient: "",
            telefono: "",
            nombreComercial: "",
            nombreSucursal: "",
            direccion: "",
            paginaWeb: "",
            correo: "",
            textoPersonalizado1: "",
            textoPersonalizado2: "",
            emitiendobank: true,
            actualizandobank: true,
            changeNumeroCuenta: 0,
            changeCci: 0,
            actualizar: false,
            validbancoguardar: true,
            otrobanco: "",
            addbank: false,
            isBusy: false,
            listaBancos: [],
            buscandoCtaDetraccion: false,
            detraccionExiste: false,
            botonesDetraccionExiste: false,
            previoModificar: false,
            vistaModificar: false,
            modificando: false,
            crearCuentaDetraccion: false,
            agregandoCuentaDet: false,
            razon_social: "",
            domicilio_fiscal: "",
            rucCliente: "",
            updateAccount: false,
            modifyAccount: false,
            modifyAccountDatos: false,
            updateClienteDatos: false,
            cuentaDetracionAdmin: "",
            addDetraccion: true,
            cuentaDetraccion: "",
            tabIndex: [0, 0],
            tabs: ["Usuario", "Contraseña", "Gestion"],
            stores: [],
            banco_fields: [
                { key: "banco", label: "Banco", sortable: true },
                { key: "tipoCuenta", label: "Tipo Cta.", sortable: true },
                { key: "moneda", label: "Moneda", sortable: true },
                { key: "numeroCuenta", label: "Cuenta", sortable: true },
                { key: "cci", label: "CCI", sortable: true },
                { key: "acciones", label: "Acciones", sortable: true }
            ],
            storeitems: [
                { key: "index", label: "#", sortable: true },
                { key: "nombreEstablecimiento", label: "Nombre", sortable: true },
                { key: "codigoEstablecimiento", label: "Código", sortable: true },
                { key: "registro", label: "Registro", sortable: true },
                { key: "ubigeo", label: "Ubigeo", sortable: true },
                { key: "direccion", label: "Direccion", sortable: true },
                { key: "acciones", label: "Acciones", sortable: true }
            ],
            banco: {
                id: 0,
                descripcion: "BCP"
            },
            Bancos: [
                { id: 0, descripcion: "BCP" },
                { id: 1, descripcion: "BBVA" },
                { id: 2, descripcion: "Interbank" },
                { id: 3, descripcion: "Scotiabank Perú" },
                { id: 4, descripcion: "PICHINCHA" },
                { id: 5, descripcion: "MiBanco" },
                { id: 6, descripcion: "BanBif" },
                { id: 7, descripcion: "Banco de Comercio" },
                { id: 8, descripcion: "Banco Pichincha" },
                { id: 9, descripcion: "Citibank Perú" },
                { id: 10, descripcion: "Banco GNB Perú" },
                { id: 11, descripcion: "Banco Falabella" },
                { id: 12, descripcion: "Banco de la Nación" },
                { id: 13, descripcion: "INGRESE NUEVO BANCO" }
            ],
            Cuentas: [
                { id: 0, descripcion: "CTA. CTE." },
                { id: 1, descripcion: "CTA. AHORROS" },
                { id: 2, descripcion: "CTA. MAESTRA" },
                { id: 3, descripcion: "T. CRÉDITO" },
                { id: 4, descripcion: "CTA. DETRACCIONES" },
                { id: 5, descripcion: "INGRESE OTRA CUENTA" }
            ],
            tipodemoneda: {
                id: "1",
                codigo: "PEN",
                descripcion: "SOLES",
                simbolo: "S/."
            },
            idBanco: "",
            tipoMoneda: TipoMoneda,
            numerocuenta: "",
            cci: "",
            cuenta: { id: 0, descripcion: "CTA. CTE." },
            otracuenta: "",
            loadingstores: false,
            namestore: "",
            codestore: "",
            loadingstores2: false,
            editidstore: "",
            editnamestore: "",
            editcodestore: "",
            loadingstores3: false,
            users: [],
            useritems: [
                { key: "index", label: "#", sortable: true },
                { key: "username", label: "Nombre", sortable: true },
                { key: "registro", label: "Registro", sortable: true },
                { key: "rol", label: "Rol", sortable: true },
                { key: "acciones", label: "Acciones", sortable: true }
            ],
            roleusers: [
                { value: 1, text: "Administrador" },
                { value: 2, text: "Operador" },
                { value: 3, text: "Consultor" }
            ],
            roleusers2: [
                { value: 1, text: "Administrador" },
                { value: 2, text: "Operador" },
                { value: 3, text: "Consultor" },
                { value: 4, text: "Asistente Contable"}
            ],
            loadingseries: false,
            userseriesf: [],
            userseriesb: [],
            userseriesncf: [],
            userseriesncb: [],
            userseriesndf: [],
            userseriesndb: [],
            userseriesgr: [],
            seriesfacturas: [],
            seriesboletas: [],
            seriesnotascf: [],
            seriesnotascb: [],
            seriesnotasdf: [],
            seriesnotasdb: [],
            seriesgr: [],
            seriesgc: [],
            seriesp: [],
            seriesoc: [],
            seriesop: [],
            seriesnv: [],
            seriesfacturasc: [],
            seriesboletasc: [],
            seriesnotascfc: [],
            seriesnotascbc: [],
            seriesnotasdfc: [],
            seriesnotasdbc: [],
            seriesgrc: [],
            show: true,
            personalizar: {
                claveNueva1: "",
                claveNueva2: ""
            },
            modalstore: false,
            modalupdate: false,
            modaluser: false,
            modaluseredit: false,
            user: {
                username: "",
                rol: "",
                idEmisor: "",
                cuenta: {
                razonSocial: ""
                },
                perfil: {}
            },
            tabs: 0,
            passvalid: false,
            loading: false,
            change: false,
            loadingusers: false,
            loadinguser: false,
            loadinguser2: false,
            // series: [],
            soptions: [
                { value: 5, text: 5 },
                { value: 15, text: 15 },
                { value: 25, text: 25 },
                { value: 50, text: 50 },
                { value: 100, text: 100 }
            ],
            sperPage: 15,
            scurrentPage: 1,
            srows: 0,
            uoptions: [
                { value: 5, text: 5 },
                { value: 15, text: 15 },
                { value: 25, text: 25 },
                { value: 50, text: 50 },
                { value: 100, text: 100 }
            ],
            uperPage: 15,
            ucurrentPage: 1,
            urows: 0,
            newuser: {
                username: "",
                perfil: {
                rol: "",
                idEstablecimiento: 0,
                appUsuario: "",
                apmUsuario: "",
                nomUsuario: "",
                rolUsuario: "",
                seriesemUsuario: {
                    "1": [],
                    "2": [],
                    "3": [],
                    "4": [],
                    "5": [],
                    "6": [],
                    "7": [],
                    "8": [],
                    "9": [],
                    "10": [],
                    "11": [],
                    "12": []
                }
                }
            },
            edituser: {
                username: "",
                perfil: {
                rol: "",
                idEstablecimiento: 0,
                appUsuario: "",
                apmUsuario: "",
                nomUsuario: "",
                rolUsuario: "",
                seriesemUsuario: {
                    "1": [],
                    "2": [],
                    "3": [],
                    "4": [],
                    "5": [],
                    "6": [],
                    "7": [],
                    "8": [],
                    "9": [],
                    "10": [],
                    "11": [],
                    "12": []
                },
                seriesconUsuario: {
                    "1": [],
                    "2": [],
                    "3": [],
                    "4": [],
                    "5": [],
                    "6": [],
                    "7": [],
                    "8": [],
                    "9": [],
                    "10": [],
                    "11": [],
                    "12": []
                }
                }
            },
            //sett
            totalRows: null,
            cargarconfigdoc: false,
            cargarconfigcode: false,
            cargarconfigacc: false,
            cargarconfigadd: false,
            cargarconfigserie: false,
            cargarconfigdoc2: false,
            cargarconfigcode2: false,
            cargarconfigacc2: false,
            cargarconfigadd2: false,
            cargarconfigserie2: false,
            cargarconfigserie3: false,
            sizes: [
                { value: "A3", text: "A3" },
                { value: "A4", text: "A4" },
                { value: "A5", text: "A5" },
                { value: "Letter", text: "CARTA" },
                { value: "Legal", text: "OFICIO" },
                { value: "Tabloid", text: "TABLOIDE" },
                { value: "Custom", text: "PERSONALIZADO" }
            ],
            size: "Custom",
            height: 80,
            witdh: 240,
            orientations: [
                { value: "portrait", text: "VERTICAL" },
                { value: "landscape", text: "HORIZONTAL" }
            ],
            orientation: "portrait",
            typecode: "QR",
            user: {
                username: "",
                rol: "",
                idEmisor: "",
                cuenta: {
                razonSocial: "",
                direccion: {}
                }
            },
            logo: "",
            changelogo: false,
            savinglogo: false,
            urlimg: null,
            modalserie: false,
            modalserieupdate: false,
            modalseriedelete: false,
            comprobants: [
                { value: 1, name: "Factura" },
                { value: 2, name: "Boleta de Venta" },
                { value: 3, name: "Nota de Crédito - Factura" },
                { value: 4, name: "Nota de Crédito - Boleta" },
                { value: 5, name: "Nota de Débito - Factura" },
                { value: 6, name: "Nota de Débito - Boleta" },
                { value: 7, name: "Guía de Remisión" },
                { value: 10, name: "Guía de Control" },
                { value: 8, name: "Proforma" },
                { value: 9, name: "Orden de Compra" },
                { value: 11, name: "Orden de Pago" },
                { value: 12, name: "Nota de Venta" }
            ],
            tabIndex: 0,
            typecomprobant: 0,
            serie: "",
            startin: 0,
            typecomprobant2: 0,
            typecomprobant3: 0,
            serie2: "",
            serie3: "",
            startin2: 0,
            idserie: "",
            series: {
                type1: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type2: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type3: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type4: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type5: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type6: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type7: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type8: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type9: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type10: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },

                cargar: false
                },
                type11: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },

                cargar: false
                },
                type12: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },

                cargar: false
                }
            },
            seriesfields: [
                { key: "index", label: "#", sortable: true },
                { key: "nombreSerie", label: "Serie", sortable: true },
                { key: "ultimoSerie", label: "Útimo", sortable: true },
                { key: "acciones", label: "Acciones", sortable: true }
            ],
            seriesall: [],
            currentPage: 1,
            tipo: 1,
            validarServicio:[],
            cod:'wenet',
            servicio: false,
            modalServicio:false,
            listDepartamento: Departamentos,
            departamentoUbigeo:'',
            provOrigen:false,
            provOrigenCargando:false,
            listProvinceOrigen: [],
            provinciaUbigeo:'',
            distOrigen:false,
            distOrigenCargando:false,
            distritoUbigeo:'',
            listDistrictOrigen: [],
            ubigeoPartida:'',
            direcUbigeo:'',
            autorizar:'',
            listaAsociados:[],
            listaAsociados_fields:[
                {key:"idContador", label:"RUC Contador"},
                {key:"fechaAfiliacion", label:"Fecha Afiliado"},
                // {key:"fechaTermino", label:"Fecha Fin"},
                {key:"estado", label:"Estado"}
            ],
            listaAsociadosTerminados:[],
            listaAsociadosTerminados_fields:[
                {key:"idContador", label:"RUC Contador"},
                {key:"fechaAfiliacion", label:"Fecha Afiliado"},
                {key:"fechaTermino", label:"Fecha Fin"},
                {key:"estado", label:"Estado"}
            ],
            servicioConta:false,
            listadoInvertido:[],
            listaUsuarioInfo:[],
            selectedInfoUsuario:null,
            idmovil:'',
            verActualizar:true,
            visible:false,
            longitud:false,
            mayus:false,
            minus:false,
            number:false,
            consultaRuc:'',
        }
    },
    watch:{
      distritoUbigeo() {
        this.distOrigenCargando = false,
        this.ubigeoPartida = this.departamentoUbigeo + this.provinciaUbigeo + this.distritoUbigeo.codDistrito
        // this.prependUbigeoOrigen = this.distritoSeleccionadoUbigeoOrigen.nombre,
        // this.modalUbigeoPartida = false
      },
      provinciaUbigeo(){
          this.distOrigen = true,
          this.distOrigenCargando = true,
          this.searchDistrictOrigen(this.distOrigenCargando)
      },
      departamentoUbigeo(){
          this.provOrigen = true;
          this.searchProvinceOrigen();
      },
    },
    mounted(){
     this.userData(),
     this.getStores()
    },
    methods: {
        userData: function() {
            this.user = this.$store.getters.userData;
        },
        getStores: function() {
        this.loadingstores = true;
        axios
            .post(process.env.VUE_APP_API_URL + "establecimientos/listar", {
            token: this.$store.getters.userToken,
            // idEmisor: this.$store.getters.userData.idEmisor,
            page: this.scurrentPage,
            limit: this.sperPage,
            ruc:this.consultaRuc
            })
            .then(
            response => (
                (this.stores = response.data.data),
                (this.loadingstores = false),
                (this.srows = response.data.total),
                this.validarContenido(this.stores)
            )).catch(error => (this.loadingstores = false));
        },
        saveStore: function() {
        this.loadingstores2 = true;
        axios
            .post(process.env.VUE_APP_API_URL + "establecimientos/crear", {
            token: this.$store.getters.userToken,
            name: this.namestore,
            code: this.codestore,
            ubigeo: this.ubigeoPartida,
            direccion: this.direcUbigeo,
            ruc: this.consultaRuc
            })
            .then(
            response => (
                this.$snotify.success(response.data.msg, "Éxito"),
                (this.loadingstores2 = false),
                (this.modalstore = false),
                (this.namestore = ""),
                (this.codestore = ""),
                this.getStores()
            )
            )
            .catch(function(error) {
            this.$snotify.error(error.response.data.msg, "Error"),
                (this.loadingstores2 = false);
            });
        },
        updateStore: function() {
        this.loadingstores3 = true;
        axios
            .post(process.env.VUE_APP_API_URL + "establecimientos/actualizar", {
            token: this.$store.getters.userToken,
            id: this.editidstore,
            updatename: this.editnamestore,
            updatecode: this.editcodestore,
            ubigeo: this.ubigeoPartida,
            direccion:this.direcUbigeo,
            ruc: this.consultaRuc
            })
            .then(
            response => (
                (this.stores = response.data.data),
                this.$snotify.success(response.data.msg, "Éxito"),
                (this.loadingstores3 = false),
                (this.modalupdate = false),
                (this.editnamestore = ""),
                (this.editcodestore = ""),
                this.getStores()
            )
            )
            .catch(function(error) {
            this.$snotify.error(error.response.data.msg, "Error"),
                (this.loadingstores3 = false);
            });
        },
        borrarEstablecimiento(value){ 
            if(this.stores.length < 2){
                this.$snotify.warning("No puede borrar la última información", "Cuidado")
            }else{
                axios
                .post(process.env.VUE_APP_API_URL + "establecimientos/borrar",{
                token: this.$store.getters.userToken,
                id: value.idEstablecimiento
                })
                .then(response=>(
                this.$snotify.success(response.data.msg),
                this.getStores()
                ))
                .catch(error=>(
                this.$snotify.error(error.response.data.msg, "Error")
                ));
            }
        },
        setStore: function(data) {
            (this.modalupdate = true),
            (this.editidstore = data.idEstablecimiento),
            (this.editnamestore = data.nombreEstablecimiento),
            (this.editcodestore = data.codigoEstablecimiento),
            (this.ubigeoPartida = data.ubigeo),
            (this.direcUbigeo = data.direccion);
        },
        validarRUC(){
            if(this.consultaRuc.length === 11){
                this.getStores();
            }else{
                this.$snotify.warning("El RUC debe contener 11 dígitos", "Cuidado")
            }
        },
        limpiarRUC(){
            this.consultaRuc = ""
        },
        validarContenido(value){
            if(value.length == []){
                this.$snotify.warning("El RUC ingresao no cuenta con Direcciones", "Ups") 
            }
        },
        searchProvinceOrigen: function () {
          this.provOrigenCargando = true
            axios
              .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
                  token: this.$store.getters.userToken,
                  department: this.departamentoUbigeo
              })
              .then(response => (
                  this.provOrigenCargando = false,
                  this.listProvinceOrigen = response.data                       
              ))
              .catch(error => {})
        },
        searchDistrictOrigen: function (value) {
        this.distOrigenCargando = value   
          axios
            .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
              token: this.$store.getters.userToken,
              department: this.departamentoUbigeo,
              province: this.provinciaUbigeo
            })
            .then(response => (
            this.listDistrictOrigen = response.data,
            this.distOrigenCargando = false
            ))
            .catch(error => {})
      },
    },
}
</script>
<style  scoped>

</style>